import { uniq } from 'lodash';

import { PermissionScope_enum } from '../../../../graphql/hasura/generated';

import type { IScopeQueriesResult } from '.';

interface ISelectPropertyTimezonesArgs {
  permissionScope: PermissionScope_enum | null | undefined;
  scopeQueriesResult: IScopeQueriesResult;
}

export function selectPropertyTimezones(args: ISelectPropertyTimezonesArgs) {
  const { permissionScope, scopeQueriesResult } = args;

  let timezones: string[] = [];
  let selectedItemName: string | undefined;

  switch (permissionScope) {
    case PermissionScope_enum.PROPERTY:
      timezones = (scopeQueriesResult.properties || []).map(p => p.timezone);
      selectedItemName = 'properties';
      break;
    case PermissionScope_enum.UNIT:
      timezones = (scopeQueriesResult.units || []).map(u => u.property.timezone);
      selectedItemName = 'units';
      break;
    case PermissionScope_enum.ACCESS_POINT:
      timezones = (scopeQueriesResult.accessPoints || []).map(a => a.property.timezone);
      selectedItemName = 'access points';
      break;
    default:
      break;
  }

  const uniqueTimezones = uniq(timezones);

  if (uniqueTimezones.length > 1) {
    return {
      propertyTimezones: uniqueTimezones,
      propertyTimezoneWarning: (
        `You have selected ${selectedItemName} in different timezones. ` +
        `Your timezone is selected by default.`
      ),
    };
  }

  return {
    propertyTimezones: uniqueTimezones,
    propertyTimezoneWarning: null,
  };
}
